import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  changeUserPassword,
  getUserByUsername,
} from "../../services/AuthService";
import { HSTSToast } from "../../utils/hstsToast";
import bcrypt from "bcryptjs";
import { ToastContainer } from "react-toastify";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";

const ChangePasswordS = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const navigator = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const [inputType, setInputType] = useState({
    old: "password",
    new: "password",
    confirm: "password",
  });

  const token = localStorage.getItem("token");
  const decodeToken = jwtDecode(token);
  let userData = decodeToken.username;

  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [valid, setValid] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const validateField = (fieldName, value) => {
    const updatedErrors = { ...errors };
    const updatedValid = { ...valid };

    if (fieldName === "oldPassword") {
      if (!value.trim()) {
        updatedErrors.oldPassword = "Current password is required.";
        updatedValid.oldPassword = false;
      } else if (!bcrypt.compareSync(value, userPassword)) {
        updatedErrors.oldPassword = "Current password is incorrect.";
        updatedValid.oldPassword = false;
      } else {
        updatedErrors.oldPassword = "";
        updatedValid.oldPassword = true;
      }
    }

    if (fieldName === "newPassword") {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

      if (!value.trim()) {
        updatedErrors.newPassword = "New password is required.";
        updatedValid.newPassword = false;
      } else if (!passwordRegex.test(value)) {
        updatedErrors.newPassword =
          "Password must be at least 8 characters long, include uppercase, lowercase, number, and special character.";
        updatedValid.newPassword = false;
      } else {
        updatedErrors.newPassword = "";
        updatedValid.newPassword = true;
      }
    }

    if (fieldName === "confirmPassword") {
      if (!value.trim()) {
        updatedErrors.confirmPassword = "Confirm password is required.";
        updatedValid.confirmPassword = false;
      } else if (value !== newPassword) {
        updatedErrors.confirmPassword = "Confirm password does not match.";
        updatedValid.confirmPassword = false;
      } else {
        updatedErrors.confirmPassword = "";
        updatedValid.confirmPassword = true;
      }
    }

    setErrors(updatedErrors);
    setValid(updatedValid);
  };

  const formValidation = () => {
    validateField("oldPassword", oldPassword);
    validateField("newPassword", newPassword);
    validateField("confirmPassword", confirmPassword);

    return (
      valid.oldPassword &&
      valid.newPassword &&
      valid.confirmPassword &&
      !errors.oldPassword &&
      !errors.newPassword &&
      !errors.confirmPassword
    );
  };

  const changePassword = (e) => {
    e.preventDefault();

    if (formValidation()) {
      const user = {
        currentPassword: oldPassword,
        newPassword: newPassword,
      };

      changeUserPassword(userId, user)
        .then(() => {
          HSTSToast("success", "Password changed successfully");
          navigator("/student/password");
        })
        .catch((error) => {
          HSTSToast("error", "Something went wrong, please try again");
          console.error(error);
        });
    }
  };

  useEffect(() => {
    getUserByUsername(userData).then((res) => {
      const resData = res.data.data;
      setUserPassword(resData.password);
      setUserId(resData.user_id);
    });
  }, [userData]);

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
        <SideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeMenu={activeMenu}
          toggleMenu={toggleMenu}
          windowWidth={windowWidth}
        />
        <div className="main-panel">
          <TopHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            windowWidth={windowWidth}
          />
          <div className="container mt-0">
            <div className="page-inner">
              <div className="page-header bg-white zis-shadow rounded-2 mt-2 ">
                <ul className="breadcrumbs my-md-3 mb-3  ms-0">
                  <li className="nav-home">
                    <Link to="/student" className="ps-3 ps-md-0">
                      <span className="fa fa-home"></span>
                    </Link>
                  </li>
                  <li className="separator">
                    <i className="fas fa-chevron-right text-secondary"></i>
                  </li>
                  <li className="nav-item text-black fw-semibold">
                    <Link to="#">Change password</Link>
                  </li>
                </ul>
              </div>

              <div className="row mt-5 align-items-center h-100">
                <form className="col-lg-4 col-12 mx-auto ">
                  <div className="card zis-shadow rounded-3">
                    <div className="card-body">
                      <div className="text-center">
                        <h1
                          className="h6 mb-3 text-black fw-semibold"
                          style={{ fontFamily: "initial", fontSize: "x-large" }}
                        >
                          Change password
                        </h1>
                      </div>

                      <div className="form-group">
                        <label className="text-black">
                          Enter current password
                        </label>
                        <input
                          type={inputType.old}
                          className={`form-control ${
                            errors.oldPassword
                              ? "is-invalid"
                              : valid.oldPassword
                              ? "is-valid"
                              : ""
                          }`}
                          value={oldPassword}
                          onChange={(e) => {
                            setOldPassword(e.target.value);
                            validateField("oldPassword", e.target.value);
                          }}
                          onFocus={() =>
                            setInputType((prev) => ({ ...prev, old: "text" }))
                          }
                          onBlur={() => {
                            setInputType((prev) => ({
                              ...prev,
                              old: "password",
                            }));
                            validateField("oldPassword", oldPassword);
                          }}
                          placeholder="Please enter current password"
                        />
                        {errors.oldPassword && (
                          <div className="invalid-feedback">
                            {errors.oldPassword}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label className="text-black">Enter new password</label>
                        <input
                          type={inputType.new}
                          className={`form-control ${
                            errors.newPassword
                              ? "is-invalid"
                              : valid.newPassword
                              ? "is-valid"
                              : ""
                          }`}
                          value={newPassword}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            validateField("newPassword", e.target.value);
                          }}
                          onFocus={() =>
                            setInputType((prev) => ({ ...prev, new: "text" }))
                          }
                          onBlur={() => {
                            setInputType((prev) => ({
                              ...prev,
                              new: "password",
                            }));
                            validateField("newPassword", newPassword);
                          }}
                          placeholder="Please enter new password"
                        />
                        {errors.newPassword && (
                          <div className="invalid-feedback">
                            {errors.newPassword}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label className="text-black">
                          Enter confirm password
                        </label>
                        <input
                          type={inputType.confirm}
                          className={`form-control ${
                            errors.confirmPassword
                              ? "is-invalid"
                              : valid.confirmPassword
                              ? "is-valid"
                              : ""
                          }`}
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            validateField("confirmPassword", e.target.value);
                          }}
                          onFocus={() =>
                            setInputType((prev) => ({
                              ...prev,
                              confirm: "text",
                            }))
                          }
                          onBlur={() => {
                            setInputType((prev) => ({
                              ...prev,
                              confirm: "password",
                            }));
                            validateField("confirmPassword", confirmPassword);
                          }}
                          placeholder="Please enter confirm password"
                        />
                        {errors.confirmPassword && (
                          <div className="invalid-feedback">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>

                      <div className="form-group mb-3">
                        <button
                          className="btn btn-black w-100 rounded-3"
                          onClick={changePassword}
                        >
                          Change password
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export default ChangePasswordS;
